import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { PAGINATION_CONFIG } from '../utils/customerConstants';

const CustomerPagination = ({
  pagination,
  currentPage,
  searchTerm,
  isLoading,
  onPageChange
}) => {
  const totalPages = pagination.pages;
  const startIndex = (pagination.page - 1) * pagination.limit;
  const endIndex = Math.min(startIndex + pagination.limit, pagination.total);

  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="mt-6 px-4 py-3 bg-gray-50 border-t border-gray-200">
      {/* Desktop Layout */}
      <div className="hidden md:flex items-center justify-between">
        <div className="flex items-center text-sm text-gray-700">
          <span>
            Showing {startIndex + 1} to {endIndex} of {pagination.total} customers
            {searchTerm && (
              <span className="text-gray-500"> (filtered)</span>
            )}
          </span>
        </div>
        <div className="flex items-center space-x-2">
          <button
            onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
            disabled={currentPage === 1 || isLoading}
            className="px-3 py-1 text-sm bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-1"
          >
            <ChevronLeft size={16} />
            <span>Previous</span>
          </button>
          
          <div className="flex items-center space-x-1">
            {Array.from({ length: Math.min(PAGINATION_CONFIG.MAX_PAGINATION_BUTTONS, totalPages) }, (_, i) => {
              let pageNumber;
              if (totalPages <= PAGINATION_CONFIG.MAX_PAGINATION_BUTTONS) {
                pageNumber = i + 1;
              } else if (currentPage <= 3) {
                pageNumber = i + 1;
              } else if (currentPage >= totalPages - 2) {
                pageNumber = totalPages - 4 + i;
              } else {
                pageNumber = currentPage - 2 + i;
              }
              
              return (
                <button
                  key={pageNumber}
                  onClick={() => onPageChange(pageNumber)}
                  disabled={isLoading}
                  className={`px-3 py-1 text-sm rounded-md ${
                    currentPage === pageNumber
                      ? 'bg-pest-blue text-white'
                      : 'bg-white border border-gray-300 hover:bg-gray-50'
                  } disabled:opacity-50`}
                >
                  {pageNumber}
                </button>
              );
            })}
          </div>
          
          <button
            onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
            disabled={currentPage === totalPages || isLoading}
            className="px-3 py-1 text-sm bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-1"
          >
            <span>Next</span>
            <ChevronRight size={16} />
          </button>
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="md:hidden">
        <div className="text-center text-sm text-gray-700 mb-3">
          <span>
            Page {currentPage} of {totalPages} ({pagination.total} customers)
            {searchTerm && (
              <span className="text-gray-500"> - filtered</span>
            )}
          </span>
        </div>
        <div className="flex items-center justify-center space-x-3">
          <button
            onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
            disabled={currentPage === 1 || isLoading}
            className="px-3 py-2 text-sm bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-1"
          >
            <ChevronLeft size={16} />
            <span>Prev</span>
          </button>
          
          <span className="px-3 py-2 text-sm font-medium bg-pest-blue text-white rounded-md">
            {currentPage}
          </span>
          
          <button
            onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
            disabled={currentPage === totalPages || isLoading}
            className="px-3 py-2 text-sm bg-white border border-gray-300 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-1"
          >
            <span>Next</span>
            <ChevronRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomerPagination;